// Builds a human-readable title for export files based on active filters.
// Used as the document title in PDF, a title row in Excel/CSV, and the filename.

const STATUS_LABELS = {
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  PENDING: 'Pending',
};

export function buildExportTitle(filters = {}) {
  const parts = [];
  if (filters.status) parts.push(STATUS_LABELS[filters.status] || filters.status);
  if (filters.committeeType) parts.push(filters.committeeType);
  if (filters.level) parts.push(filters.level);
  if (filters.wing) parts.push(filters.wing);
  if (filters.gender) parts.push(filters.gender);
  if (filters.casteCategory) parts.push(filters.casteCategory);
  if (filters.mandal) parts.push(`Mandal: ${filters.mandal}`);
  if (filters.panchayat) parts.push(`Panchayat: ${filters.panchayat}`);
  if (filters.withoutPhoto === 'true' || filters.withoutPhoto === true) parts.push('Without Photo');
  if (filters.fromDate || filters.toDate) {
    parts.push(`${filters.fromDate || '…'} to ${filters.toDate || '…'}`);
  }
  if (filters.search) parts.push(`Search: "${filters.search}"`);

  return parts.length ? `Registrations — ${parts.join(' • ')}` : 'Registrations — All';
}

export function buildExportFilename(filters = {}, ext = 'pdf') {
  const parts = [];
  if (filters.status) parts.push(String(filters.status).toLowerCase());
  if (filters.committeeType) parts.push(String(filters.committeeType).toLowerCase().replace(/\s+/g, '-'));
  if (filters.mandal) parts.push(String(filters.mandal).toLowerCase().replace(/\s+/g, '-'));
  const base = ['registrations', ...parts].join('_').replace(/[^a-z0-9_\-]/gi, '');
  return `${base}.${ext}`;
}
